import { Spinner } from "@mixitone/components";
import type { TournamentCompetition } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import RoundRobinStandings from "./RoundRobinStandings";
import SwissStandings from "./SwissStandings";
import TournamentStandingsController from "./TournamentStandingsController";

interface TournamentStandingsProps {
  competitionId: string;
  competition?: TournamentCompetition;
}

const TournamentStandings = ({ competition }: TournamentStandingsProps) => {
  const controller = TournamentStandingsController.use();
  const { loading, error, standingsData } = controller.state;

  if (loading) {
    return <Spinner size={64} />;
  }

  if (error) {
    return <div className="py-4 text-center text-red-500">{error}</div>;
  }

  // If no competition is provided, we would normally fetch it
  if (!competition) {
    return <div className="py-4 text-center text-gray-500">Competition not found</div>;
  }

  // If no standings data is available
  if (!standingsData) {
    return <div className="py-4 text-center text-gray-500">No standings data available</div>;
  }

  // Render the appropriate standings component based on format
  switch (competition.format) {
    case "RoundRobin":
      return <RoundRobinStandings />;
    case "Swiss":
    case "SwissWithDivisions":
      return <SwissStandings />;
    default:
      return null;
  }
};

export default TournamentStandingsController.scope(ApplicationView(TournamentStandings));
